export default "__VITE_ASSET__DcbI1Blc__"